import React from "react";
import { FinishingOptionsTab } from "../../../types/ContentfulTypes";
import { TranslatedHeader, ProductPageTabHeaderProps } from "../../ProductPageTabHeaders";
import { showFinishingOptions } from "./FinishingOptionsHelper";

export const FinishingOptionsHeader = (props: ProductPageTabHeaderProps) => {
  const { tab } = props;

  if (!showFinishingOptions(tab?.value as FinishingOptionsTab)) {
    return null;
  }

  return <TranslatedHeader {...props} />;
};
